<template>
  <div class="question">
    <div class="question__wrapper">
      <div class="question__q">
        Q: {{ currentPosition }}/{{ totalQuestions }}
      </div>
      <div
        class="question__content"
        v-html="currentQuestion.content || currentQuestion.question_html"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Question',
  props: {
    currentQuestion: {
      type: Object,
      required: true,
    },
    currentPosition: {
      type: Number,
      required: true,
    },
    totalQuestions: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.question {
  &__wrapper {
    box-shadow: none;
    @include desktop {
      flex-wrap: wrap;
      padding-right: 20px;
    }
  }
  &__q {
    font-weight: 700;
    font-size: 32px;
    margin: 0 20px 0 0;
  }
  &__content {
    font-size: 1rem;
    margin: 0;
    padding: 20px 0 0 0;
    width: 100%;
    word-break: break-word;
    @include desktop {
      font-size: 22px;
      width: 100%;
      box-sizing: border-box;
      flex: 1;
    }
  }
  img {
    max-width: 450px;
  }
}
</style>
